module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"pending_reviews":"可寫評論 {count}","written_reviews":"我的評論 {count}"}}')
  delete Component.options._Ctor
}
